import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast, ToastType } from './toast.model';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  toasts = signal<Toast[]>([]);
  toastToRemove = signal<Set<number>>(new Set());
  private counter = 0;

  show(message: string, type: ToastType = 'info', duration = 6000): void {
    const id = ++this.counter;
    this.toasts.update(t => [...t, { id, message, type }]);
    setTimeout(() => this.remove(id), duration);
  }

  remove(id: number): void {
    this.toastToRemove.update(s => new Set([...s, id]));
    setTimeout(() => {
      this.toasts.update(t => t.filter(t => t.id !== id));
      this.toastToRemove.update(s => { s.delete(id); return new Set(s); });
    }, 200);
  }
}
